import { GrowthBook } from '@growthbook/growthbook'
import firebase from 'firebase/compat/app'
import {
  COHORT_FIREBASE_KEYS_MAP,
  COHORT_GROWTHBOOK_KEYS_MAP,
} from 'nove8/constants/ab-tests'
import { Cohort } from 'nove8/constants/root-constants'
import {
  CurrentEnvironment,
  EventLoggerInstanceName,
  RUDDERSTACK_DATA_PLANE_URL,
  RUDDERSTACK_WRITE_KEY_DEV,
  RUDDERSTACK_WRITE_KEY_PROD,
} from 'root-constants'
import { eventLogger } from 'services/eventLogger.service'
import { Rudderstack } from 'services/rudderstack.service'
import { getAbTestOptions } from './getAbTestOptions'
import { getGrowthbookVariantData } from './getGrowthbookVariantData'
import { getRemoteConfigVariantData } from './getRemoteConfigVariantData'
import { mergeAbTestVariantData } from './mergeAbTestVariantData'

export const addRudderstackLogger = ({
  uuid,
  utmTags,
  cohort,
  language,
  firebaseRemoteConfig,
  growthbook,
  country,
}: {
  uuid: string
  utmTags: Record<string, string>
  cohort: Cohort
  language: string
  firebaseRemoteConfig: firebase.remoteConfig.RemoteConfig | null
  growthbook: GrowthBook | null
  country: string
}): void => {
  const remoteConfigVariantValue = mergeAbTestVariantData({
    cohort,
    firebaseRemoteConfigVariantData: getRemoteConfigVariantData({
      firebaseRemoteConfig,
      firebaseRemoteConfigKey: COHORT_FIREBASE_KEYS_MAP[cohort],
    }),
    growthbookVariantData: getGrowthbookVariantData({
      growthbook,
      growthbookKey: COHORT_GROWTHBOOK_KEYS_MAP[cohort],
    }),
  })

  const woofzAbTestOptions = getAbTestOptions({
    cohort,
    language,
    remoteConfigVariantValue,
    country,
  })

  const rudderstackService = new Rudderstack({
    writeKey:
      import.meta.env.CURRENT_ENV === CurrentEnvironment.PROD
        ? RUDDERSTACK_WRITE_KEY_PROD
        : RUDDERSTACK_WRITE_KEY_DEV,
    dataPlaneUrl: RUDDERSTACK_DATA_PLANE_URL,
    instanceName: EventLoggerInstanceName.RUDDERSTACK,
    userId: uuid,
    utmTags: {
      ...utmTags,
      uuid,
    },
    cohort,
    options: woofzAbTestOptions || {},
  })

  eventLogger.addLoggers([rudderstackService])
}
